import { OpenTable } from '@/screens/index'

export default function () {
  return <OpenTable />
}
